import vm from '@/main.js'

/**
 * @description 图片base64转file
 * @param {String} dataUrl - 图片base64路径
 * @param {String} fileName - 图片名称
 */
const base64ToFile = (dataUrl, fileName) => {
    var arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
}

/**
 * @description 图片file转base64
 * @param {File} file - 图片文件
 * @param {Function} callback - 接收回调
 */
const fileToBase64 = (file, callback) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function(e) {
      if (callback) {
        callback(e.target.result);
      }
    }
}

/**
 * @description 文件上传生成随机数
 * @param {Number} n - 位数
 */
const rndNum = (n) => {
    var rnd = "";
    for(var i=0;i<n;i++)
        rnd += Math.floor(Math.random()*10);
    return parseInt(new Date().getTime()) + '' + rnd;
}

/**
 * @description 身份证号验证
 * @param {String} code - 身份证号
 */
const checkIdCard = (code) => {
    var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
    // var tip = "";
    var pass = true;
    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        // tip = "身份证号格式错误";
        pass = false;
        console.log('身份证号格式错误')
    } else if (!city[code.substr(0, 2)]) {
        // tip = "地址编码错误";
        pass = false;
        console.log('地址编码错误')
    } else {
      //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            // var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
            // tip = "校验位错误";
            pass = false;
            console.log('校验位错误')
            }
        }
    }
    return pass;
}

/**
 * @description 手机号验证
 * @param {String} theObj - 手机号
 */
const checkPhone = (theObj) => {
    var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
    if (reg.test(theObj)) {
        // console.log('是手机号');
        return true;
    } else {
        // console.log('不是手机号');
        return false;
    }
}

/**
 * @description 数据字典筛选某项数据
 * @param {String} dicName
 */
const getDicList = (dicName) => {
    let dictionary = vm.$byStoreGet('dictionary');
    let dicList = dictionary.filter(item => {
        return item.dictionaryCode == dicName;
    })
    if(dicList.length == 1) {
        return JSON.parse(dicList[0].content);
    }else{
        console.log('获取数据字典出错');
    }
}

/**
 * @description 数据字典获取中文
 * @param {String} dicName
 * @param {String} value
 */
const getDicLabel = (dicName, value) => {
    let dictionary = vm.$byStoreGet('dictionary');
    let dicList = dictionary.filter(item => {
        return item.dictionaryCode == dicName;
    })
    if(dicList.length == 1) {
        let dic = JSON.parse(dicList[0].content);
        let item = dic.filter(item => {
            return item.value == value;
        })
        if(item.length == 1) {
            return item[0].label;
        }else{
            console.log('数据字典值解析错误');
        }
    }else{
        console.log('数据字典名称解析错误');
    }
}

/**
 * @abstract 富文本编辑器校验
 */
const checkEditor = (str) => {
    let num = 0,
    reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g;
    while (num < str.length && content != ""){
        num++;
        let k = str.match(reg);
        if (k) {
            str = str.replace(k[0], "");
        }
    }
    return str == "";
}

/**
 * @description 页面跳转
 * @param {String} routeName 路由名
 * @param {Object} routeParam 路由参数
 */
const jump = (routeName, routeParam) => {
    if(routeParam) vm.$byStoreSet(routeName, routeParam);
    vm.$router.push({ name:routeName });
}

const getSignStatus = (param)=>{
  if(param == 0){
    return '未预约'
  }
  if (param == 1) {
    return '已预约'  //未签到
  }
  if (param == 2) {
    return '已签到'
  }
  if (param == 3) {
    return '已签到'
  }
}

let common = {
    base64ToFile,
    fileToBase64,
    rndNum,
    checkIdCard,
    checkPhone,
    getDicList,
    getDicLabel,
    checkEditor,
    jump,
    getSignStatus
}
export default common;
